const CTM_TAGS = {
  COMPUTE_TASK: "ComputeTask"
};
const CTM_URL_SEGMENTS = {
  Compute: "compute",
  TASKS: "tasks"
};
export {
  CTM_TAGS,
  CTM_URL_SEGMENTS
};
//# sourceMappingURL=common.js.map
